export class SmokeEffect extends Phaser.GameObjects.Container {

    constructor(scene: Phaser.Scene) {

        super(scene);

        const n = 5;

        for (let i = 0; i < n; i ++) {

            const smokeParticle = new Phaser.GameObjects.Image(this.scene, 0, 0, "texture_atlas_1", "smoke_particle");
            this.add(smokeParticle);

            smokeParticle.setScale(0);
            smokeParticle.angle = Math.random() * 360;
            smokeParticle.alpha = 0;

            const x = 12 - 24 * Math.random();
            const y = -60 - 60 * Math.random();
            const t = Math.round(500 + 500 * Math.random());
            const s = .6 + .2 * Math.random();

            this.scene.tweens.add({
                targets: smokeParticle,
                alpha: 1,
                scaleX: s,
                scaleY: s,
                ease: Phaser.Math.Easing.Cubic.Out,
                duration: 300
            });

            this.scene.tweens.add({
                targets: smokeParticle,
                x: x,
                y: y,
                ease: Phaser.Math.Easing.Linear,
                duration: t,
                delay: 100
            });

            this.scene.tweens.add({
                targets: smokeParticle,
                alpha: 0,
                scaleX: .5,
                scaleY: .5,
                ease: Phaser.Math.Easing.Cubic.Out,
                duration: 400,
                delay: t - 400,
                onComplete: function(): void {

                    this.n ++;

                    if (this.n === n) {
                        this.destroy();
                    }
                },
                onCompleteScope: this
            });
        }
    }
}

